import React, { useState } from "react";
import "./PatientsDetailsForm.css";
import { useLocation, useNavigate } from "react-router-dom";
import PatientTypeForm from "./PatientTypeForm";

const PatientsDetailsForm = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // states
  const [formNum, setFormNum] = useState(1);
  const [bookingFor, setBookingFor] = useState("");
  const [formValues, setFormValues] = useState({});

  const {
    slotId,
    availabilityId,
    clinicId,
    doctorId,
    date,
    endTime,
    startTime,
    type = "ONLINE",
  } = location.state;

  function onChangeFormInput(e) {
    const name = e.target.name;
    const value = e.target.value;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  }

  function isValidFormValues(values) {
    return !!(
      values.name &&
      values.gender &&
      values.phone &&
      values.dateOfBirth
    );
  }

  function onFormSubmit(e) {
    e.preventDefault();
    if (isValidFormValues(formValues)) {
      navigate("/checkout", {
        state: {
          patient: formValues,
          slotId,
          availabilityId,
          clinicId,
          doctorId,
          date,
          endTime,
          startTime,
          bookingFor,
          type,
        },
      });
    }
  }

  async function onClickSubmit() {
    if (bookingFor === "myself") {
      navigate("/checkout", {
        state: {
          slotId,
          availabilityId,
          clinicId,
          doctorId,
          date,
          endTime,
          startTime,
          bookingFor,
          type,
        },
      });
    } else {
      setFormNum(2);
    }
  }

  function onClickBack() {
    console.log("doc id", doctorId);
    navigate(doctorId ? `/docterdetails/${doctorId}` : "/");
  }

  return (
    <div id="layout">
      <div className="backButton" onClick={onClickBack}>
        <svg width="20" height="20" viewBox="0 0 13 13" fill="none">
          <rect
            width="13"
            height="13"
            transform="matrix(-1 0 0 1 13 0)"
            fill="url(#pattern0)"
          />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#image0_509_325" transform="scale(0.00390625)" />
            </pattern>
            <image
              id="image0_509_325"
              width="256"
              height="256"
              xlinkHref="data:image/png;base64,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"
            />
          </defs>
        </svg>
      </div>
      <div className="PatientsDetailsForm_header">
        <h1>Tell us a bit about you.</h1>
        <p>To book your appointment, we need the following details.</p>
      </div>
      {formNum === 1 ? (
        <PatientTypeForm
          onClickSubmit={onClickSubmit}
          bookingFor={bookingFor}
          setBookingFor={setBookingFor}
        />
      ) : formNum === 2 ? (
        <form onSubmit={onFormSubmit}>
          <div className="patient_details_inputs">
            <div>
              <label htmlFor="name">Full Name</label>
              <div className="patient_input_icon">
                <svg
                  width="15"
                  height="19"
                  viewBox="0 0 15 19"
                  fill="none"
                  className="input_icon_patient"
                >
                  <path
                    d="M7.00014 18.8702C6.73773 18.8374 6.47486 18.8081 6.2129 18.7709C5.2328 18.6323 4.30509 18.304 3.43384 17.7965C2.04634 16.9885 0.941127 15.8403 0.101491 14.3788C-0.0209087 14.1652 -0.0340068 13.9745 0.0698749 13.7446C0.830922 12.0606 2.03279 10.9824 3.68948 10.5241C3.82046 10.4878 3.9546 10.4674 4.08649 10.4362C4.34754 10.3746 4.57202 10.455 4.78701 10.6219C5.6429 11.2874 6.59997 11.5848 7.64376 11.5342C8.43687 11.4959 9.20018 11.2839 9.83882 10.7674C10.3167 10.381 10.7769 10.3979 11.2905 10.5553C12.7416 11.0008 13.8365 11.9528 14.6061 13.3707C14.934 13.975 14.9448 13.985 14.5925 14.5695C13.7258 16.0082 12.6003 17.133 11.1893 17.8983C10.1586 18.457 9.0692 18.7748 7.92153 18.8448C7.88449 18.8473 7.84836 18.8607 7.81132 18.8692H7.00014V18.8702Z"
                    fill="#D5D5D5"
                  />
                  <path
                    d="M7.74666 0.5625C8.1649 0.674238 8.60437 0.729363 8.99776 0.907648C10.4887 1.58553 11.397 2.81266 11.6747 4.57118C11.9832 6.52337 11.1129 8.51331 9.50814 9.46234C7.94585 10.386 6.38943 10.2917 4.93237 9.17431C3.76257 8.27742 3.14651 6.99566 3.11986 5.42635C3.09005 3.68273 3.77432 2.31307 5.08368 1.33474C5.6618 0.902681 6.30948 0.665796 7.00504 0.588324C7.03665 0.584848 7.06692 0.571439 7.09808 0.5625H7.74712L7.74666 0.5625Z"
                    fill="#D5D5D5"
                  />
                </svg>
              </div>
              <input
                onChange={onChangeFormInput}
                name="name"
                type="text"
                className="patient_details_input"
                placeholder="Please enter full name"
                required
              />
            </div>
            <div className="gender_box">
              <label htmlFor="gender">Gender</label>
              <input
                onChange={onChangeFormInput}
                className="checkbox-tools"
                type="radio"
                name="gender"
                id="tool-1"
                value="MALE"
              />
              <label className="for-checkbox-tools" htmlFor="tool-1">
                Male
              </label>
              <input
                onChange={onChangeFormInput}
                className="checkbox-tools"
                type="radio"
                name="gender"
                id="tool-2"
                value="FEMALE"
              />
              <label className="for-checkbox-tools" htmlFor="tool-2">
                Female
              </label>
              <input
                onChange={onChangeFormInput}
                className="checkbox-tools"
                type="radio"
                name="gender"
                id="tool-3"
                value="OTHER"
              />
              <label className="for-checkbox-tools" htmlFor="tool-3">
                Others
              </label>
            </div>
            <div>
              <label htmlFor="name">Email</label>
              <div className="patient_input_icon">
                <svg
                  width="15"
                  height="20"
                  viewBox="0 0 21 15"
                  fill="none"
                  className="input_icon_patient"
                >
                  <path
                    d="M20.6715 3.49713V12.6079C20.6642 12.6182 20.6529 12.6276 20.6498 12.639C20.3872 13.6903 19.7493 14.1901 18.6673 14.1901C13.3987 14.1901 8.13067 14.1901 2.86208 14.1901C2.79746 14.1901 2.73285 14.1912 2.66875 14.1886C1.62971 14.1518 0.862579 13.3687 0.861545 12.3277C0.857927 9.43303 0.859995 6.53888 0.861028 3.64422C0.861028 3.59761 0.870333 3.55151 0.876536 3.49609C0.911171 3.51526 0.928747 3.52303 0.944772 3.5339C3.62042 5.32125 6.29555 7.1086 8.9712 8.89594C10.1715 9.69769 11.36 9.69924 12.5613 8.89698C14.9532 7.30075 17.3435 5.70296 19.7353 4.10672C20.0455 3.90007 20.3598 3.69964 20.672 3.49661L20.6715 3.49713Z"
                    fill="#D5D5D5"
                  />
                  <path
                    d="M20.672 2.08697C20.5981 2.28432 20.5588 2.50491 20.4425 2.6728C20.2843 2.90114 20.0976 3.13413 19.8707 3.28704C17.1809 5.09464 14.4844 6.89191 11.7822 8.68143C11.1159 9.12261 10.4128 9.12106 9.74641 8.67988C7.03957 6.88623 4.33842 5.08328 1.6383 3.27981C0.99002 2.8469 0.721714 2.09679 0.927467 1.34926C1.13787 0.584686 1.79339 0.0629156 2.60968 0.0102219C2.66758 0.00660568 2.72548 0.00608898 2.7839 0.00608898C8.10452 0.00608898 13.4246 0.00557237 18.7453 0.00608898C19.6267 0.00608898 20.3153 0.477232 20.5758 1.25421C20.612 1.36269 20.6405 1.47428 20.672 1.58432V2.08697Z"
                    fill="#D5D5D5"
                  />
                </svg>
              </div>
              <input
                onChange={onChangeFormInput}
                type="text"
                pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                id="email"
                name="email"
                size="30"
                className="patient_details_input"
                placeholder="Please enter email"
              />
            </div>
            <div>
              <label htmlFor="name">Date of Birth</label>
              <div className="patient_input_icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  className="input_icon_patient"
                >
                  <path
                    d="M6.66667 1.66675V4.16675M13.3333 1.66675V4.16675M2.91667 7.57508H17.0833M17.5 7.08341V14.1667C17.5 16.6667 16.25 18.3334 13.3333 18.3334H6.66667C3.75 18.3334 2.5 16.6667 2.5 14.1667V7.08341C2.5 4.58341 3.75 2.91675 6.66667 2.91675H13.3333C16.25 2.91675 17.5 4.58341 17.5 7.08341Z"
                    stroke="#D5D5D5"
                    strokeWidth="1.25"
                    stroke-miterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13.0791 11.4165H13.0866M13.0791 13.9165H13.0866M9.99579 11.4165H10.0041M9.99579 13.9165H10.0041M6.91162 11.4165H6.91995M6.91162 13.9165H6.91995"
                    stroke="#D5D5D5"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <input
                onChange={onChangeFormInput}
                type="date"
                name="dateOfBirth"
                className="patient_details_input"
              />
            </div>
            <div>
              <label htmlFor="phone">Phone</label>
              <div className="patient_input_icon">
                <p className="input_icon_patient input_icon_phone">+91</p>
              </div>
              <input
                // {...register("name")}
                onChange={onChangeFormInput}
                name="phone"
                // value={InputNum}
                type="number"
                className="patient_details_input"
                placeholder="Please enter phone"
                pattern="^\d{10}$"
                required
              />
            </div>
          </div>
          <div className="patients_details_next_cta">
            <button type="submit" className="">
              Next
            </button>
          </div>
        </form>
      ) : (
        <div>null</div>
      )}
    </div>
  );
};

export default PatientsDetailsForm;
